import React from 'react';
import { Text } from '../../components/text';
export var ItemTitle = function (_a) {
    var _b;
    var section = _a.section, item = _a.item;
    if (((_b = section.show) === null || _b === void 0 ? void 0 : _b.title) === false) {
        return null;
    }
    return (React.createElement(Text, { align: section.title.align, color: section.title.color, fontFamily: section.title.fontFamily, fontSize: section.title.fontSize, fontStyle: section.title.fontStyle, fontWeight: section.title.fontWeight || undefined, lineHeight: section.title.lineHeight, textDecoration: section.title.textDecoration, padding: "0px" }, item.title));
};
//# sourceMappingURL=item-title.js.map